// packages/blocks.ts
const blockModules = import.meta.glob('./block-*/index.tsx', { eager: true });
const BLOCKS = Object.values(blockModules).map((mod) => mod.default);
export default BLOCKS;
//# sourceMappingURL=blocks.js.map